<template>
    <v-dialog
        v-model="handleDialog"
        scrollable
        max-width="700px"
      >
        <v-card class="setting-card">
            <v-card-title>表示設定</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="setting-main">
                <div class="setting-row">
                    <v-row class="pb-4">
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.contract_informations.control_number" :label="`管理番号`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.contract_informations.control_title" :label="`管理タイトル`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.object_id" :label="`契約書ID`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.contract_name" :label="`契約書名`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.agreement.contract_name" :label="`件名`"></v-checkbox>
                        </v-col>
                    </v-row>
                </div>
                <div class="setting-row">
                    <v-row class="pb-4">
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.agreement.contract_status" :label="`状態`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.agreement.signature_method" :label="`署名方式`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.agreement.updated_at" :label="`更新/登録日時`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.agreement.conclusion_date" :label="`契約締結日`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.to_company_names" :label="`契約先`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.sender_name" :label="`送信者/登録者`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.organization_names" :label="`共有グループ`"></v-checkbox>
                        </v-col>
                    </v-row>
                </div>
                <div class="setting-row">
                    <v-row class="pb-4">
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.contract_informations.transaction_amount" :label="`取引金額`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.contract_informations.memo" :label="`取引先`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.contract_informations.contract_start_date" :label="`契約開始日`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.contract_informations.contract_end_date" :label="`契約終了日`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.contract_informations.cancellation_notice_deadline" :label="`解約通知期限`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.contract_informations.contract_information_last_updated_datetime" :label="`契約情報更新日時`"></v-checkbox>
                        </v-col>
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.contract_informations.is_automatic_updating" :label="`自動更新の有無`"></v-checkbox>
                        </v-col>
                    </v-row>
                </div>
                <div class="setting-row" v-if="displaySetting.user_defined_items.length > 0">
                    <v-row class="pb-4">
                        <v-col v-for="ud_item in displaySetting.user_defined_items" :key="ud_item.id" cols="auto">
                            <v-checkbox hide-details v-model="ud_item.value" :label="ud_item.item_name"></v-checkbox>
                        </v-col>
                    </v-row>
                </div>
                <div class="setting-row">
                    <v-row class="pb-4">
                        <v-col cols="auto">
                            <v-checkbox hide-details v-model="displaySetting.contract_alerts" :label="`アラート`"></v-checkbox>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
            <section>
               <v-card-actions class="justify-center grey lighten-4 pb-6">
                    <v-btn min-width="150px" class="white--text handle-btn" color="blue-grey lighten-1" large @click="handleDialog = false">
                        <slot name="cancel-btn">閉じる</slot>
                    </v-btn>
                </v-card-actions> 
            </section>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            itemSettingDialog: Boolean,
            displaySetting: Object,
        },
        data() {
            return {
            };
        },
        computed: {
            handleDialog: {
                get() {
                    return this.itemSettingDialog;
                },
                set(value) {
                    window.localStorage.setItem('all_document_display_setting', JSON.stringify(this.displaySetting))
                    this.$emit('setDisplaySetting', this.displaySetting);
                    // 親コンポーネントへの通知
                    this.$emit('input', value);
                }
            },
    
        },
    };
</script>

<style scoped>
.setting-title{
    font-size:13px!important;
    font-weight: bold;
}
.setting-row{
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    margin-bottom: 10px;
    box-shadow: 1px 1px 1px #8080804f;
}
::v-deep .v-dialog{
    transform-origin: center center;
    width: 45%;
    height: 600px;
    background-color: white;
}

::v-deep .setting-card{
    display: flex;
    flex-flow: column;
    min-height: 100%;
    margin: 0;
}

::v-deep .setting-card .v-toolbar__content{
    font-size: 15px;
}

::v-ddep .setting-main{
    flex: 1;
}

::v-deep .v-input--selection-controls{
    margin-top: 0px !important;
    padding-top: 0px !important;
}

::v-deep .v-card__text .v-label {
    font-size: 1.2rem !important;
    color: black !important;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-size: 1.2rem !important;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > th {
    font-size: 1.2rem !important;
}

::v-deep .handle-btn{
    height: 30px !important;
}

::v-deep .handle-btn .v-btn__content {
    font-size: 1.2rem !important;
}

::v-deep .v-card__title, .v-card__text {
    font-size: 1.5rem !important;
}
</style>